import React from "react";

import { useMediaQuery } from "@mui/material";

import DetalleTransaccional from "../../layouts/DetalleTransaccional";
import DetalleTransaccionalMobile from "../../layouts/DetalleTransaccionalMobile";

const ClienteProspeccion = ({ datosBusqueda, setDatosBusqueda }) => {
  const transactionModeMobile = useMediaQuery("(max-width:769px)");

  return (
    <>
      {transactionModeMobile ? (
        <DetalleTransaccionalMobile
          datosBusqueda={datosBusqueda}
          setDatosBusqueda={setDatosBusqueda}
        />
      ) : (
        <DetalleTransaccional
          datosBusqueda={datosBusqueda}
          setDatosBusqueda={setDatosBusqueda}
        />
      )}
    </>
  );
};

export default ClienteProspeccion;
